import React, { useEffect, Component, useState } from 'react';
import { AppStore, CurrentUserStore } from 'stores';
import { withRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { DealershipChooser } from 'components';

import { Tabs, Row, Col } from 'antd';
import Inspections from './Inspections';
import Templates from './Templates';

function InspectionForms() {
  const location = useLocation();
  const tabState = location.state?.tab;

  const items = [
    {
      key: '1',
      label: 'Inspection Forms',
      children: <Inspections />,
    },
    ...(CurrentUserStore.allowManager
      ? [
          {
            key: '2',
            label: 'Templates',
            children: <Templates />,
          },
        ]
      : []),
  ];

  const tabKeyFromState = tabState === 'templates' ? '2' : '1';

  const [activeKey, setActiveKey] = useState(tabKeyFromState);

  useEffect(() => {
    AppStore.setSelectedSidebarKey('/inspection-forms');
  }, []);
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        maxWidth: '90vw',
        boxSizing: 'border-box',
        margin: '0 auto',
      }}
    >
      <Row>
        <Col>
          <DealershipChooser />
        </Col>
      </Row>
      <Tabs
        defaultActiveKey="1"
        items={items}
        activeKey={activeKey}
        onChange={setActiveKey}
      />
    </div>
  );
}

export default InspectionForms;
